import { render, staticRenderFns } from "./OpenGuidedTourBtn.vue?vue&type=template&id=0a68e551&scoped=true&"
import script from "./OpenGuidedTourBtn.vue?vue&type=script&lang=ts&"
export * from "./OpenGuidedTourBtn.vue?vue&type=script&lang=ts&"
import style0 from "./OpenGuidedTourBtn.vue?vue&type=style&index=0&id=0a68e551&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68e551",
  null
  
)

export default component.exports